/* ribogrow: buy buttons that put the pack INTO the cart and then open the cart (since 02.11.2026).
   - Sales pages (snippets/rg-sp-buy.liquid, box [data-sp-cart-buy]): pack choice (1 bottle / bundle); the button [data-sp-add]
     adds the selected pack. Nothing that is already in the cart is removed. Then the cart pop-up of the theme opens (same as
     in the shop, with "Dazu passend"; window.rgCart.addItems, assets/rg-cart.js). sections/rg-sp-header.liquid hides the
     theme header there but keeps its cart pop-up (#x-cart-drawer-container). Without the pop-up: cart page.
   - Buttons with data-rg-cart="VARIANT:QTY" (e.g. sections/rg-lp-hero.liquid) and remaining links /cart/VARIANT:QTY on a page
     that loads this file: same.
   - The cart icon in the sales page header (.sp-cart) opens the cart pop-up as well (link to the cart page as fallback).
   - No cart permalinks as button targets: the theme preloads links on touch / hover (instant.page, layout/theme.liquid), and
     preloading a permalink /cart/VARIANT:QTY makes Shopify REPLACE the whole cart. Remaining permalinks on the page are marked
     data-no-instant so they are not preloaded.
   - An active discount code (discount link /discount/CODE or ?discount=CODE) stays: with the pop-up, a code that came in
     via ?discount= is applied in the background first (/discount/CODE?redirect=/cart.js); the cart page opens via
     /discount/CODE?redirect=/cart.
   - The cart count in the sales page header ([data-sp-cart-count], sections/rg-sp-header.liquid) is refreshed on load and when
     the page comes back via the back button.
   Links marked data-rg-permalink are left alone. */
(function () {
  'use strict';
  if (window.rgSpCartInit) return;
  window.rgSpCartInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var ERROR = 'Das hat leider nicht geklappt. Bitte versuchen Sie es erneut.';

  function codeNow() {
    var c = '';
    try { var q = new URLSearchParams(window.location.search); c = q.get('discount') || q.get('code') || ''; } catch (e) {}
    if (!c) {
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      if (m) { try { c = decodeURIComponent(m[1]); } catch (e) { c = m[1]; } }
    }
    c = String(c || '').trim();
    return /^[A-Za-z0-9_-]{2,40}$/.test(c) ? c : '';
  }
  function cartUrl() {
    var code = codeNow();
    return code ? root + 'discount/' + encodeURIComponent(code) + '?redirect=' + root + 'cart' : root + 'cart';
  }
  function addItems(items) {
    return fetch(root + 'cart/add.js', { method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin', body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }
  /* "VARIANT:QTY,VARIANT:QTY" -> [{ id, quantity }] or null */
  function itemsFromList(list) {
    list = String(list || '').trim();
    if (!/^\d+:\d+(?:,\d+:\d+)*$/.test(list)) return null;
    return list.split(',').map(function (pair) {
      var p = pair.split(':');
      return { id: Number(p[0]), quantity: Math.max(1, Number(p[1]) || 1) };
    });
  }
  function itemsFromLink(href) {
    var u;
    try { u = new URL(href, window.location.href); } catch (e) { return null; }
    if (u.origin !== window.location.origin) return null;
    var m = u.pathname.match(/\/cart\/(\d+:\d+(?:,\d+:\d+)*)\/?$/);
    return m ? itemsFromList(m[1]) : null;
  }
  function setBusy(btn, on) {
    var label = btn.querySelector('[data-sp-label]');
    clearTimeout(btn.rgCartTimer);
    if (on) {
      if (label && !btn.hasAttribute('data-sp-idle')) {
        btn.setAttribute('data-sp-idle', label.textContent);
        label.textContent = btn.getAttribute('data-busy') || 'Wird hinzugefügt …';
      }
      btn.classList.add('is-busy');
      btn.setAttribute('aria-busy', 'true');
    } else {
      if (label && btn.hasAttribute('data-sp-idle')) {
        label.textContent = btn.getAttribute('data-sp-idle');
        btn.removeAttribute('data-sp-idle');
      }
      btn.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
    }
  }
  function isSalesPage() {
    return !!document.querySelector('[data-sp-top]');
  }
  /* the theme's cart pop-up (Alpine store xMiniCart), or null when it is not on the page */
  function drawer() {
    var A = window.Alpine;
    var M = A && A.store && A.store('xMiniCart');
    var H = A && A.store && A.store('xCartHelper');
    if (!M || !H || typeof M.openCart !== 'function' || window.rgCartType === 'page') return null;
    if (!document.getElementById('x-cart-drawer-container')) return null;
    if (!window.rgCart || typeof window.rgCart.addItems !== 'function') return null;
    return M;
  }
  function openDrawer(M) {
    setTimeout(function () {
      try { if (window.Alpine.store('xModal')) window.Alpine.store('xModal').setActiveElement('cart-icon'); } catch (e) {}
      M.openCart();
    }, 0);
  }
  /* a code from ?discount= is not in the cart session yet: apply it once in the background (same as the discount link) */
  var codeSent = {};
  function keepCode() {
    var c = codeNow();
    if (!c || codeSent[c.toLowerCase()]) return Promise.resolve();
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/), ck = '';
    if (m) { try { ck = decodeURIComponent(m[1]); } catch (e) { ck = m[1]; } }
    if (ck && ck.toLowerCase() === c.toLowerCase()) return Promise.resolve();
    codeSent[c.toLowerCase()] = 1;
    return fetch(root + 'discount/' + encodeURIComponent(c) + '?redirect=' + root + 'cart.js', { credentials: 'same-origin' })
      .then(function () {}, function () {});
  }

  /* adds the items, then opens the cart pop-up (or the cart page when there is none). On an error: the message below the
     button; without a message line the jump target of the button (e.g. #rg-buybox), otherwise a short alert. Never a
     permalink, so the cart is never replaced. */
  function buy(btn, items, msg, error) {
    if (btn.classList.contains('is-busy')) return;
    if (msg) msg.textContent = '';
    setBusy(btn, true);
    function fail() {
      setBusy(btn, false);
      if (msg) { msg.textContent = error || ERROR; return; }
      var h = btn.getAttribute('href') || '';
      if (h.charAt(0) === '#' && h.length > 1) window.location.hash = h;
      else window.alert(error || ERROR);
    }
    if (isSalesPage() ? drawer() : (window.rgCart && typeof window.rgCart.addItems === 'function')) {
      keepCode()
        .then(function () { return window.rgCart.addItems(items); })
        .then(function () { setBusy(btn, false); refreshCount(); }, fail);
      return;
    }
    addItems(items).then(function () {
      window.location.href = cartUrl();
      btn.rgCartTimer = setTimeout(function () { setBusy(btn, false); }, 15000);
    }, fail);
  }

  /* ---------- sales pages: pack choice + button ---------- */
  function initBox(box) {
    if (box.hasAttribute('data-sp-cart-ready')) return;
    box.setAttribute('data-sp-cart-ready', '');
    var btn = box.querySelector('[data-sp-add]');
    var label = btn && btn.querySelector('[data-sp-label]');
    var gift = box.querySelector('[data-sp-gift]');
    var msg = box.querySelector('[data-sp-msg]');
    function sync() {
      var input = box.querySelector('input[type=radio]:checked');
      var opt = input && input.closest('[data-sp-opt]');
      box.querySelectorAll('[data-sp-opt]').forEach(function (o) { o.classList.toggle('is-selected', o === opt); });
      if (!opt || !btn) return;
      btn.setAttribute('data-variant', opt.getAttribute('data-variant'));
      var text = opt.getAttribute('data-label');
      if (label && text) {
        if (btn.hasAttribute('data-sp-idle')) btn.setAttribute('data-sp-idle', text);
        else label.textContent = text;
      }
      if (gift) gift.hidden = opt.getAttribute('data-gift') !== 'true';
      if (msg) msg.textContent = '';
    }
    box.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') sync();
    });
    sync();
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      buy(btn, [{ id: Number(btn.getAttribute('data-variant')), quantity: 1 }], msg, box.getAttribute('data-error'));
    });
  }

  /* ---------- cart count in the sales page header ---------- */
  function refreshCount() {
    var els = document.querySelectorAll('[data-sp-cart-count]');
    if (!els.length) return;
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        els.forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = !cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* remaining permalinks /cart/VARIANT:QTY must not be preloaded (instant.page skips data-no-instant) */
  function guardPermalinks(scope) {
    (scope || document).querySelectorAll('a[href*="/cart/"]').forEach(function (a) {
      if (itemsFromLink(a.getAttribute('href'))) a.setAttribute('data-no-instant', '');
    });
  }

  function init(scope) {
    scope = scope || document;
    guardPermalinks(scope);
    scope.querySelectorAll('[data-sp-cart-buy]').forEach(initBox);
  }

  /* ---------- cart icon in the sales page header: cart pop-up instead of the cart page ---------- */
  document.addEventListener('click', function (e) {
    if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a.sp-cart');
    if (!a) return;
    var M = drawer();
    if (!M) return;
    e.preventDefault();
    e.stopPropagation();
    openDrawer(M);
  }, true);
  /* changes inside the pop-up (quantity, remove, "Dazu passend") -> cart count in the sales page header */
  var countTimer = null;
  ['eurus:cart:items-changed', 'eurus:product:added', 'cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, function () { clearTimeout(countTimer); countTimer = setTimeout(refreshCount, 300); });
  });

  /* ---------- buttons data-rg-cart="VARIANT:QTY" and links /cart/VARIANT:QTY ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[data-rg-cart], a[href]');
    if (!a || a.hasAttribute('data-sp-add') || a.hasAttribute('data-rg-permalink')) return;
    var items = a.hasAttribute('data-rg-cart') ? itemsFromList(a.getAttribute('data-rg-cart')) : itemsFromLink(a.getAttribute('href'));
    if (!items) return;
    e.preventDefault();
    buy(a, items, null, null);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); refreshCount(); });
  else { init(document); refreshCount(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-sp-add].is-busy, a.is-busy').forEach(function (b) { setBusy(b, false); });
    refreshCount();
  });
  /* for other buy buttons on the page (sections/rg-sticky-atc.liquid): keep a ?discount= code before adding */
  window.rgSpKeepCode = keepCode;
})();